<template>
  <common-dialog
    ref="dialog"
    title="New Note"
    :inputs-map="newNote"
    :input-value-change="valueChange"
    :save-cb="saveNewNote"
    :reset-inputs="resetInputs"
  />
</template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
// models
import { NewNoteForm } from '@/core/models/note'
// mixin
import { dialogMixin } from '@/core/mixin/dialog'
// components
import CommonDialog from '@/components/common/CommonDialog.vue'
export default {
  name: 'NoteEdit',
  mixins: [dialogMixin],
  components: {
    CommonDialog
  },
  data() {
    return {
      newNote: Object.values(cloneDeep(NewNoteForm)),
      saveCb: null
    }
  },
  methods: {
    saveNewNote(info, done, error) {
      // todo 需要检查 输入的东西是否正确
      info.createdTime = new Date().toISOString()
      this.saveCb(info, done, error)
    },
    open(saveCb = null) {
      this.$refs.dialog.open()
      this.saveCb = saveCb
    },
    resetInputs() {
      this.$set(this, 'newNote', Object.values(cloneDeep(NewNoteForm)))
    },
    valueChange() {},
    close() {
      this.$refs.dialog.close()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';
</style>
